<div class="modal-wrapper">
  <div class="modal-header">
    <h5 tabindex="0" ngbAutofocus class="modal-title">Manage Conflict</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('cross click')"></button>
  </div>
  <div class="modal-body">
    @if (moreConflicts) {
      <div class="row col-12">
        <div class="col-sm-12 col-md-8">You have multiple conflicts in your Waitlist Management.</div>
        <div class="col-sm-12 col-md-4"><button class="btn btn-sm btn-primary col-12" [routerLink]="'catalog'" [queryParams]="{tab: 'waitlistManagement'}">Manage All Conflicts</button></div>
      </div>
    }
    <div class="row w-100 px-2">
      <conflict [enrollment]="enrollment" [instructors]="instructors" (isDropped)="activeModal.dismiss('close')"></conflict>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('close')">Close</button>
  </div>
</div>
